<template>
  <PCSettingsBlock :title="t('common.information')">
    <PCSettingsBlockItem :title="t('userConfiguration.information.version.title')">
      <template #right>
        {{ APP_VERSION }}
      </template>
    </PCSettingsBlockItem>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { APP_VERSION } from '@/js/common/constants';
import { useI18n } from 'vue-i18n';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
</script>
